// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact {
  height: fit-content;
  position: relative;
  margin: 4rem auto;
}

/* > Mobile */
.contact-content {
  width: 100%;
  margin: 200px 0 3rem 0;
  position: relative;
  margin-bottom: 4rem;
  padding-left: 1rem;
  padding-right: 1rem;
}

section.contact-content_section {
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 4rem;
}
.contact-content h1,
h3,
p,
a {
  color: var(--blackBg);
}

.contact-title {
  color: var(--darkGrey);
  opacity: 0.9;
}
.contact-subtitle {
  margin-top: 2rem;
  display: flex;
}
.contact-subtitle:hover {
  background-color: var(--light-blackBg);
  color: var(--secondaryColor);
  padding-left: 3rem;
  padding-right: 3rem;
  transition: all 0.5s ease-out;
}

.contact-content_article p > a {
  color: inherit;
}

.contact-form-container {
  display: flex;
  flex-direction: column;
}
.vertical-divider {
  display: none;
}
.horizontal-divider {
  display: block;
}
.brace {
  width: auto;
  min-width: 35px;
  padding-bottom: 20px;
  font-size: 2em;
  line-height: 2em;
  position: relative;
  text-align: center;
  vertical-align: middle;
  margin: 0 15px 15px;
  border: none;
  background-color: transparent;
  background-image: radial-gradient(
      circle at 0 0,
      rgba(var(--secondaryColor), 0) 14.5px,
      var(--secondaryColor) 15.5px,
      var(--secondaryColor) 19.5px,
      rgba(var(--secondaryColor), 0) 20.5px
    ),
    radial-gradient(
      circle at 35px 0,
      rgba(var(--secondaryColor), 0) 14.5px,
      var(--secondaryColor) 15.5px,
      var(--secondaryColor) 19.5px,
      rgba(var(--secondaryColor), 0) 20.5px
    );
  background-size: 35px 20px;
  background-position: center bottom;
  background-repeat: no-repeat;
  text-transform: lowercase;
  font-style: italic;
  color: var(--secondaryColor);
  filter: drop-shadow(0 1px 1px rgba(black, 0.15));
  overflow: visible;
}
.brace:before {
  width: 50%;
  border-top: 5px solid var(--secondaryColor);
  border-left: 1px solid transparent; /* play with this until you like the look of it */
  border-top-left-radius: 20% 30px;
  height: 100%;
  content: '';
  position: absolute;
  top: 4rem;
  right: 0;
  box-sizing: border-box;
  margin-top: -5px;
}

.brace:after {
  width: 50%;
  border-top: 5px solid var(--secondaryColor);
  border-right: 1px solid transparent; /* play with this until you like the look of it */
  border-top-right-radius: 20% 30px;
  height: 100%;
  content: '';
  position: absolute;
  top: 4rem;
  left: 0;
  box-sizing: border-box;
  margin-top: -5px;
}

/* > Tablet */
@media only screen and (min-width: 677px) {
  .contact-content {
    padding-top: 4rem;
    margin-bottom: 6rem;
  }

  section.contact-content_section {
    flex-direction: row;
    justify-content: space-evenly;
    align-items: baseline;
  }
  .contact-content_article {
    margin-left: 2rem;
    width: 50%;
  }
  .contact-form-container {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
  .vertical-divider {
    position: absolute;
    display: table;
    text-align: center;

    height: 55%;
    width: 100%;
  }

  .vertical-divider .center-element {
    position: relative;
    display: table-cell;
    vertical-align: middle;
  }
  .vertical-divider .center-element:before,
  .center-element:after {
    position: absolute;
    content: '';
    width: 1px;
    left: 50%;
    border-left: 1px solid black;
  }
  .vertical-divider .center-element:before {
    bottom: 50%;
    top: 0;
    margin-bottom: 20px;
  }
  .vertical-divider .center-element:after {
    top: 50%;
    bottom: 0;
    margin-top: 20px;
  }

  .horizontal-divider {
    display: none;
  }
}

/* > Big Desktop */
@media only screen and (min-width: 1024px) {
  .contact-content_bottom {
    padding-bottom: 8rem;
  }
  .contact-content_article {
    font-size: 1.5em;
    max-width: 100%;
    letter-spacing: 2px;
    line-height: 1.6em;
  }
  section.contact-content_bottom {
    margin: 3rem 0;
    padding-left: 0;
    padding-top: 11rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/css/contact.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,aAAa;AACb;EACE,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;AACA;;;;EAIE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,sCAAsC;EACtC,4BAA4B;EAC5B,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,6BAA6B;EAC7B;;;;;;;;;;;;;KAaG;EACH,0BAA0B;EAC1B,kCAAkC;EAClC,4BAA4B;EAC5B,yBAAyB;EACzB,kBAAkB;EAClB,4BAA4B;EAC5B,gDAAgD;EAChD,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,2CAA2C;EAC3C,kCAAkC,EAAE,iDAAiD;EACrF,gCAAgC;EAChC,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,2CAA2C;EAC3C,mCAAmC,EAAE,iDAAiD;EACtF,iCAAiC;EACjC,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,aAAa;AACb;EACE;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,6BAA6B;IAC7B,qBAAqB;EACvB;EACA;IACE,iBAAiB;IACjB,UAAU;EACZ;EACA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;EAChC;EACA;IACE,kBAAkB;IAClB,cAAc;IACd,kBAAkB;;IAElB,WAAW;IACX,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;EACxB;EACA;;IAEE,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,SAAS;IACT,4BAA4B;EAC9B;EACA;IACE,WAAW;IACX,MAAM;IACN,mBAAmB;EACrB;EACA;IACE,QAAQ;IACR,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,kBAAkB;AAClB;EACE;IACE,oBAAoB;EACtB;EACA;IACE,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,kBAAkB;EACpB;EACA;IACE,cAAc;IACd,eAAe;IACf,kBAAkB;EACpB;AACF","sourcesContent":[".contact {\n  height: fit-content;\n  position: relative;\n  margin: 4rem auto;\n}\n\n/* > Mobile */\n.contact-content {\n  width: 100%;\n  margin: 200px 0 3rem 0;\n  position: relative;\n  margin-bottom: 4rem;\n  padding-left: 1rem;\n  padding-right: 1rem;\n}\n\nsection.contact-content_section {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 4rem;\n}\n.contact-content h1,\nh3,\np,\na {\n  color: var(--blackBg);\n}\n\n.contact-title {\n  color: var(--darkGrey);\n  opacity: 0.9;\n}\n.contact-subtitle {\n  margin-top: 2rem;\n  display: flex;\n}\n.contact-subtitle:hover {\n  background-color: var(--light-blackBg);\n  color: var(--secondaryColor);\n  padding-left: 3rem;\n  padding-right: 3rem;\n  transition: all 0.5s ease-out;\n}\n\n.contact-content_article p > a {\n  color: inherit;\n}\n\n.contact-form-container {\n  display: flex;\n  flex-direction: column;\n}\n.vertical-divider {\n  display: none;\n}\n.horizontal-divider {\n  display: block;\n}\n.brace {\n  width: auto;\n  min-width: 35px;\n  padding-bottom: 20px;\n  font-size: 2em;\n  line-height: 2em;\n  position: relative;\n  text-align: center;\n  vertical-align: middle;\n  margin: 0 15px 15px;\n  border: none;\n  background-color: transparent;\n  background-image: radial-gradient(\n      circle at 0 0,\n      rgba(var(--secondaryColor), 0) 14.5px,\n      var(--secondaryColor) 15.5px,\n      var(--secondaryColor) 19.5px,\n      rgba(var(--secondaryColor), 0) 20.5px\n    ),\n    radial-gradient(\n      circle at 35px 0,\n      rgba(var(--secondaryColor), 0) 14.5px,\n      var(--secondaryColor) 15.5px,\n      var(--secondaryColor) 19.5px,\n      rgba(var(--secondaryColor), 0) 20.5px\n    );\n  background-size: 35px 20px;\n  background-position: center bottom;\n  background-repeat: no-repeat;\n  text-transform: lowercase;\n  font-style: italic;\n  color: var(--secondaryColor);\n  filter: drop-shadow(0 1px 1px rgba(black, 0.15));\n  overflow: visible;\n}\n.brace:before {\n  width: 50%;\n  border-top: 5px solid var(--secondaryColor);\n  border-left: 1px solid transparent; /* play with this until you like the look of it */\n  border-top-left-radius: 20% 30px;\n  height: 100%;\n  content: '';\n  position: absolute;\n  top: 4rem;\n  right: 0;\n  box-sizing: border-box;\n  margin-top: -5px;\n}\n\n.brace:after {\n  width: 50%;\n  border-top: 5px solid var(--secondaryColor);\n  border-right: 1px solid transparent; /* play with this until you like the look of it */\n  border-top-right-radius: 20% 30px;\n  height: 100%;\n  content: '';\n  position: absolute;\n  top: 4rem;\n  left: 0;\n  box-sizing: border-box;\n  margin-top: -5px;\n}\n\n/* > Tablet */\n@media only screen and (min-width: 677px) {\n  .contact-content {\n    padding-top: 4rem;\n    margin-bottom: 6rem;\n  }\n\n  section.contact-content_section {\n    flex-direction: row;\n    justify-content: space-evenly;\n    align-items: baseline;\n  }\n  .contact-content_article {\n    margin-left: 2rem;\n    width: 50%;\n  }\n  .contact-form-container {\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n  }\n  .vertical-divider {\n    position: absolute;\n    display: table;\n    text-align: center;\n\n    height: 55%;\n    width: 100%;\n  }\n\n  .vertical-divider .center-element {\n    position: relative;\n    display: table-cell;\n    vertical-align: middle;\n  }\n  .vertical-divider .center-element:before,\n  .center-element:after {\n    position: absolute;\n    content: '';\n    width: 1px;\n    left: 50%;\n    border-left: 1px solid black;\n  }\n  .vertical-divider .center-element:before {\n    bottom: 50%;\n    top: 0;\n    margin-bottom: 20px;\n  }\n  .vertical-divider .center-element:after {\n    top: 50%;\n    bottom: 0;\n    margin-top: 20px;\n  }\n\n  .horizontal-divider {\n    display: none;\n  }\n}\n\n/* > Big Desktop */\n@media only screen and (min-width: 1024px) {\n  .contact-content_bottom {\n    padding-bottom: 8rem;\n  }\n  .contact-content_article {\n    font-size: 1.5em;\n    max-width: 100%;\n    letter-spacing: 2px;\n    line-height: 1.6em;\n  }\n  section.contact-content_bottom {\n    margin: 3rem 0;\n    padding-left: 0;\n    padding-top: 11rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
